<template>
  <div>
    <b-form-input
        v-model="field"
        class="form-control form-control-sm"
        :id="id"
        @blur="popoverShow = false"
        @keyup.native="SearchAddressByName"
    />
    <b-popover
        ref="popover"
        :target="id"
        :show.sync="popoverShow"
        :disabled.sync="popoverDisabled"
        placement="bottom"
    >
      <template v-slot:title>
        <div class="d-flex justify-content-between align-items-center">
          <span>Suche</span>
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="close"
              variant="transparent"
              aria-label="Close"
          >
            <span
                class="d-inline-block text-white"
                aria-hidden="true"
            >&times;</span>
          </b-button>
        </div>
      </template>

      <div>
        <b-table
                 class="row-pointer"
                 :items="items"
                 :fields="fields"
                 @rowClicked.passive="SelectAddressBySearch"
        >
          <template #cell(Address)="row" @click="SelectAddressBySearch">
            {{row.item.Address.Street }} {{row.item.Address.Zipcode }} {{row.item.Address.Location }}
          </template>
          <template #cell(Btn)="row">
            <b-button
                @click="SelectAddressBySearch(row.item.AddressId)"
                class="btn-sm btn-info"
            >
              auswählen
            </b-button>
          </template>
        </b-table>
      </div>
    </b-popover>
  </div>
</template>

<script>
import Remark from '@/views/voucher/Remark'
import Cleave from 'vue-cleave-component'
import BCardCode from '@core/components/b-card-code'
import {
  BTable,
  BFormCheckbox,
  BBadge,
  BFormSelect,
  BButton,
  BCol,
  BFormGroup,
  BFormInput,
  BRow,
  BDropdown,
  BDropdownDivider,
  BDropdownForm,
  BDropdownGroup,
  BDropdownItem,
  BPopover,
  BTab,
  BTabs,
  BInputGroupPrepend,
  BInputGroupAppend,
  VBTooltip, BInputGroup, BSpinner, BFormDatepicker
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { VueAutosuggest } from 'vue-autosuggest'

export default {
  name: 'AddressSearch',
  computed: {
    make() {
      this.id = this.makeid(24);
    }
  },
  components: {
    BFormCheckbox,
    BTab,
    BTabs,
    BFormSelect,
    Cleave,
    BTable,
    Remark,
    BCardCode,
    VueAutosuggest,
    BPopover,
    BDropdown,
    BDropdownDivider,
    BDropdownForm,
    BDropdownGroup,
    BDropdownItem,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BRow,
    BCol,
    BButton,
    BBadge,
    BInputGroupPrepend,
    BInputGroupAppend,
    BSpinner,
    BFormDatepicker
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      id: this.makeid(48),
      timeout: null,
      field: '',
      fieldSelected: '',
      selected: null,
      popoverShow: false,
      popoverDisabled: false,
      showLimit: 5,
      fields: [
        {
          key: 'Contact.Name',
          label: 'Name',
        },
        {
          key: 'Address',
          label: 'Adresse',
        },
        {
          key: 'Btn',
          label: 'Aktion',
        }
      ],
      items: [],
      options: {
        date: {
          date: true,
          delimiter: '.',
          datePattern: ['d', 'm', 'y'],
        },
        time: {
          time: true,
          timePattern: ['h', 'm'],
        },
        number: {
          numeral: true,
        },

      },

    }
  },
  mounted() {

  },
  methods: {
    makeid(length) {
      var result           = '';
      var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },
    ClickRow(record, index) {
      console.log(record)
    },
    SelectAddressBySearch(number) {
      this.field = number;
      this.fieldSelected = number;
    },
    async SearchAddressByName() {
      this.popoverShow = true
      clearTimeout(this.timeout);
      console.log(this.field)
      this.timeout = setTimeout(() => {
        let rData = []
        this.$http.post('/address', JSON.stringify({
          Value: this.field,
        }))
            .then(resp => {
              let count = 0
              resp.data.forEach(i => {
                if (count > this.showLimit) {
                  return
                }

                rData.push(i)
                count++
              })
            })
            .catch(err => {
              console.error(err)
            })
        this.items = rData
      }, 300)


    },
  }
}
</script>

<style scoped>
.popover {
  max-width: 100%; /* Max Width of the popover (depending on the container!) */
}

.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>

<style lang="scss">
.vue2leaflet-map {
  &.leaflet-container {
    height: 350px;
  }
}
</style>
